import { useOfferContext } from '../../../context';
import React from 'react';
import { ExtensionLabel } from '../../../components/ExtensionLabel';

export function PriceExtensionLabelContainer() {
  const { priceExtensionLabel } = useOfferContext();

  if (!priceExtensionLabel) {
    return null;
  }

  return <ExtensionLabel text={priceExtensionLabel} />;
}
